import { render, staticRenderFns } from "./PersonnelChanges.vue?vue&type=template&id=cdafcb62"
import script from "./PersonnelChanges.vue?vue&type=script&lang=js"
export * from "./PersonnelChanges.vue?vue&type=script&lang=js"
import style0 from "./PersonnelChanges.vue?vue&type=style&index=0&id=cdafcb62&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports